export default "__VITE_ASSET__b813ffc3__"